import EnclosureCommon from "./enclosureCommon";
import {METADATA} from "../../constants";

export default class SkirtingBoard extends EnclosureCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'skirting_board';
    this.partName = 'Skirting Board';
    this.translateId = "visualizer.bathroom.accessories.skirting_board";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["BathType"]) {
      dbFeature.metaData["BathType"] = [METADATA.BathtubWithoutEnclosures]; // for free standing bath
    }
    return super.load(dbFeature);
  }

}
